"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class SearchHistory extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'searchHistory';
        this._accountId = initParams.account_id;
        this._metadata = initParams.metadata;
        this._name = initParams.name;
        this._itemId = initParams.item_id;
        this._itemType = initParams.item_type;
        this._created = initParams.created;
    }
    set accountId(value) {
        console.error('Do not set objects this way');
    }
    get accountId() {
        return this._accountId;
    }
    set metadata(value) {
        console.error('Do not set objects this way');
    }
    get metadata() {
        return this._metadata;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set itemId(value) {
        console.error('Do not set objects this way');
    }
    get itemId() {
        return this._itemId;
    }
    set itemType(value) {
        console.error('Do not set objects this way');
    }
    get itemType() {
        return this._itemType;
    }
    set created(value) {
        console.error('Do not set objects this way');
    }
    get created() {
        return this._created;
    }
    delete() {
        return this.dataService.deleteSearchHistory(this.id, this);
    }
}
exports.default = SearchHistory;
//# sourceMappingURL=searchHistory.js.map